import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { tabletQuery } from '../../../../utils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { ONLINE_INFO_CONSTANTS } from '../../../../constants/onlineInfo';

export const OnlineInfoPc = () => {
  const { getText } = useTextVariant(ONLINE_INFO_CONSTANTS, false);

  return (
    <Container>
      <Item>
        <TitleContainer>
          <img src={ImageUtils.NumberIcon1} alt="Number Icon 1" />
          <Title>{getText('step1Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg1 src={ImageUtils.GuideImg1} />
          <ContentText>{getText('step1Content')}</ContentText>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step1Warning')}</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <img src={ImageUtils.NumberIcon2} alt="Number Icon 2" />
          <Title>{getText('step2Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg3 src={ImageUtils.GuideImg3} />
          <ContentText>{getText('step2Content')}</ContentText>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step2Warning')}</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <img src={ImageUtils.NumberIcon3} alt="Number Icon 3" />
          <Title>{getText('step3Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg2 src={ImageUtils.GuideImg2} />
          <ContentTextType2>{getText('step3Content')}</ContentTextType2>
        </Content>
        <WaringContainer>
          <WaringText>{getText('step3Warning1')}</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <img src={ImageUtils.NumberIcon4} alt="Number Icon 4" />
          <Title>{getText('step4Title')}</Title>
        </TitleContainer>
        <Content>
          <ContentImg4 src={ImageUtils.GuideImg4} />
          <ContentText>{getText('step4Content')}</ContentText>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 100px;
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 110px;
  padding-left: 16px;
  padding-right: 16px;
`;

const Item = styled.div`
  width: calc(50% - 2px);
  margin-bottom: 22px;
  margin-right: 1px;
  margin-left: 1px;

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(odd) ${Content} {
    background: #2b1f1f;
  }

  &:nth-child(even) ${Content} {
    background: #27241d;
  }

  ${tabletQuery} {
    width: 100%;
  }
`;

const TitleContainer = styled.div`
  background: #1d1a1a;
  height: 34px;
  padding-left: 14px;
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`;

const Title = styled.h3`
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.4px;
`;

const ContentText = styled.h4`
  color: rgba(255, 255, 255, 0.6);
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  white-space: pre-wrap;

  span {
    font-weight: 700;
  }

  strong {
    color: #3fb5ff;
  }
`;

const ContentTextType2 = styled(ContentText)`
  margin-top: 20px;
`;

const ContentImg = styled.img`
  margin-right: 11px;
`;

const ContentImg1 = styled(ContentImg)`
  width: 222px;
`;

const ContentImg2 = styled(ContentImg)`
  width: 155px;
`;

const ContentImg3 = styled(ContentImg)`
  width: 175px;
`;

const ContentImg4 = styled(ContentImg)`
  width: 150px;
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  margin-top: 12px;
`;

const WaringText = styled.li`
  color: #8e8e8e;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.64px;
  position: relative;

  &:after {
    content: '';
    width: 5px;
    height: 5px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
  }

  strong {
    color: white;
    text-decoration: underline;
  }
`;
